import script from "./PendingEventDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./PendingEventDialog.vue?vue&type=script&lang=ts&setup=true"

import "./PendingEventDialog.vue?vue&type=style&index=0&id=d2182988&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2182988"]])

export default __exports__